// extracted by mini-css-extract-plugin
module.exports = {"mCard":"Xf","image":"Yf","imageNoBackground":"Zf"};